import {
  AnalyticsAttributes,
  GTM,
  useSetGlobalAnalyticsProperties,
} from '@app/analytics';

import { isServer } from '@app/utils';

import { useIsomorphicLayoutEffect } from 'react-use';

import { useAllAbVariants, useAllExperiments } from '@app/experiments';

const useExperimentsAnalytics = () => {
  const variants = useAllAbVariants();
  const experiments = useAllExperiments();
  const setGlobalAnalyticsProperties = useSetGlobalAnalyticsProperties();

  useIsomorphicLayoutEffect(() => {
    if (isServer || !variants?.length) {
      return;
    }

    const variantsAsString = variants?.join(',');
    if (!variantsAsString) {
      return;
    }

    // GA
    setGlobalAnalyticsProperties({
      [AnalyticsAttributes.cdLaunchDarklyExperiments]: variantsAsString,
    });

    // Segment
    // GTM
    // GTM we send all the experiments. not just ab tests
    GTM.pushToDataLayer({ event: 'experiments_initialized', experiments });
  }, [experiments, setGlobalAnalyticsProperties, variants]);
};

export default useExperimentsAnalytics;
